<template>
  <Bar :chart-data="data" :chart-options="options" />
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import { Bar } from "vue-chartjs";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {

  props: {
    data: Object,
    options: Object,
  },

  data: () => ({}),

  components: { Bar },

};
</script>
